import styled from "styled-components";
import {GridColumnContainer} from "../../styledcomponents/MiscStyledComponents";
import React, {CSSProperties, ReactElement} from "react";

export const ButtonBarButton = styled.button<{ float?: 'right' | 'left' , active?: boolean  }>`
  background-color: ${props => props.active ? '#E6F2FA' : 'white'};
  color : ${props => props.active ? 'black' : '#353434b2'};
  border: 2px solid ${props => props.active ? '#004376' : '#D2D2D2'};
  border-radius: 6px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  max-height: 50px;
  text-decoration: none;
  float: ${props => props.float ?? 'right'};
  align-self: ${props => props.float === 'left' ? 'start' : 'end'};
  text-align: center;

  &:hover:enabled {
    color: black !important;
    background-color: #E6F2FA !important;
    border-color: #004376;
  }

  &:disabled {
    opacity: .5;
    cursor: default;
    background-color: #D2D2D2 !important;
    color: #464646 !important;
    border: 1px solid #6E6E6E !important;
  }

  display: block;
  width: 100%;
  padding: 0.6rem 0.8rem;
  justify-self: center;
`

const ButtonBarWrapper = styled(GridColumnContainer)`
  background-color : #f5f5f5;
  padding: 20px;
  border-bottom: 2px solid #D2D2D2;

`

type ButtonBarProps = {
    children : ReactElement[];
    style ?: CSSProperties;
}

export function ButtonBar(props : ButtonBarProps) {
    return (
        <ButtonBarWrapper columns={props.children.length} style={props.style}>
            {props.children}
        </ButtonBarWrapper>
    )
}